import Ghoma from "../../core/assets/oot/ennemies/cleanup/ghoma_200x200.png"
import KD from "../../core/assets/oot/ennemies/cleanup/king_dodongo_200x200.png"
import Barinade from "../../core/assets/oot/ennemies/cleanup/barinade_200x200.png"
import PG from "../../core/assets/oot/ennemies/cleanup/pg_200x200.png"
import Volvagia from "../../core/assets/oot/ennemies/cleanup/volvagia_200x200.png"
import Morpha from "../../core/assets/oot/ennemies/cleanup/morpha_200x200.png"
import Bongo from "../../core/assets/oot/ennemies/cleanup/bongo_200x200.png"
import Twinrova from "../../core/assets/oot/ennemies/cleanup/twinrova_200x200.png"
import Stone from "../../core/assets/oot/gshd/gossip-stone_32x32.png"
import Triforce from "../../core/assets/oot/classic/Triforce_Artwork.png"
import { useState } from "react"
import { Box } from "@mui/material"
import { isNil, max, min } from "lodash"

interface BossSelectorProps{
    additionalOnCheck?: (index: number) => void
    value?: number
}
export const bosses = [Stone, Ghoma, KD, Barinade, PG, Volvagia, Morpha, Bongo, Twinrova, Triforce]

const BossSelector = (props: BossSelectorProps) => {

   

    let [index, setIndex]= useState(props.value ?? 0)

    

    return <Box onWheelCapture={(e: React.WheelEvent<HTMLDivElement>) => {
        e.preventDefault();
        let newIndex = 0;
        if (e.deltaY > 0 && index === 0) newIndex = 9;
        else if (e.deltaY > 0) newIndex = max([0, index - 1]) ?? 0;
        else if (e.deltaY > 0 && index === 9) {
            newIndex = 0;
        } else if (e.deltaY < 0 && index === 9) newIndex = 0;
        else if (e.deltaY < 0) newIndex = min([9, index + 1]) ?? 0;
        else newIndex = 9;

        if (!isNil(props.additionalOnCheck)) 
            props.additionalOnCheck(newIndex);
        setIndex(newIndex);
      }}
      sx={{backgroundColor: "rgba(111,111,111,0.5)"}}>

        <img src={bosses[index]} alt="" height={32} width={32}/>
    </Box>
}

export default BossSelector